// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ExplainInsightsWorkbookSupportQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  queryId: Types.Scalars["ID"]["input"];
}>;

export type ExplainInsightsWorkbookSupportQuery = {
  __typename?: "GraphqlQuery";
  getQueryDetails: {
    __typename?: "Query";
    id: string;
    supportsWorkbooks: boolean;
  };
};

export const ExplainInsightsWorkbookSupportDocument = gql`
  query ExplainInsightsWorkbookSupport($databaseId: ID!, $queryId: ID!) {
    getQueryDetails(databaseId: $databaseId, queryId: $queryId) {
      id
      supportsWorkbooks
    }
  }
`;

/**
 * __useExplainInsightsWorkbookSupportQuery__
 *
 * To run a query within a React component, call `useExplainInsightsWorkbookSupportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplainInsightsWorkbookSupportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplainInsightsWorkbookSupportQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      queryId: // value for 'queryId'
 *   },
 * });
 */
export function useExplainInsightsWorkbookSupportQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExplainInsightsWorkbookSupportQuery,
    ExplainInsightsWorkbookSupportQueryVariables
  > &
    (
      | {
          variables: ExplainInsightsWorkbookSupportQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExplainInsightsWorkbookSupportQuery,
    ExplainInsightsWorkbookSupportQueryVariables
  >(ExplainInsightsWorkbookSupportDocument, options);
}
export function useExplainInsightsWorkbookSupportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExplainInsightsWorkbookSupportQuery,
    ExplainInsightsWorkbookSupportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExplainInsightsWorkbookSupportQuery,
    ExplainInsightsWorkbookSupportQueryVariables
  >(ExplainInsightsWorkbookSupportDocument, options);
}
// @ts-ignore
export function useExplainInsightsWorkbookSupportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExplainInsightsWorkbookSupportQuery,
    ExplainInsightsWorkbookSupportQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExplainInsightsWorkbookSupportQuery,
  ExplainInsightsWorkbookSupportQueryVariables
>;
export function useExplainInsightsWorkbookSupportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExplainInsightsWorkbookSupportQuery,
        ExplainInsightsWorkbookSupportQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExplainInsightsWorkbookSupportQuery | undefined,
  ExplainInsightsWorkbookSupportQueryVariables
>;
export function useExplainInsightsWorkbookSupportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExplainInsightsWorkbookSupportQuery,
        ExplainInsightsWorkbookSupportQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExplainInsightsWorkbookSupportQuery,
    ExplainInsightsWorkbookSupportQueryVariables
  >(ExplainInsightsWorkbookSupportDocument, options);
}
export type ExplainInsightsWorkbookSupportQueryHookResult = ReturnType<
  typeof useExplainInsightsWorkbookSupportQuery
>;
export type ExplainInsightsWorkbookSupportLazyQueryHookResult = ReturnType<
  typeof useExplainInsightsWorkbookSupportLazyQuery
>;
export type ExplainInsightsWorkbookSupportSuspenseQueryHookResult = ReturnType<
  typeof useExplainInsightsWorkbookSupportSuspenseQuery
>;
export type ExplainInsightsWorkbookSupportQueryResult = Apollo.QueryResult<
  ExplainInsightsWorkbookSupportQuery,
  ExplainInsightsWorkbookSupportQueryVariables
>;
